module.exports = __webpack_public_path__ + "static/media/google-play.efb7093a.png";